<div *ngIf = ClientMapping>


    <div class="row ">
        <div class="col pl-3">
            <h4 class="mb-0 font-header" style="font-weight: 700;"><label (click)="MovetoEmployeeParent()"><i
                        class="fa fa-chevron-circle-left" title="Close"
                        style="font-size:24px"></i></label>&nbsp;Employee Client Info
            </h4>
        </div>
    </div>
    <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId==0">
        <div class="row mt-4 ">
            <div class="col ">
                <div widget class="card border-0 box-shadow">
                    <div class="card-body  widget-body pt-2">
                        <div class="text-center text-danger">
                            <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                                agency to view
                                details</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- QP Mapping and Supervision Mapping both in one modal...If u change anything verify if it effect any other places... -->
    <!-- list -->
    <div class="row mt-4"
        *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!=0">
        <div class="col ">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2" style="min-height: 500px;"><br>
                    <div class="row">
                        <div class="ml-auto">
                            <button class="btn blue-btn btn-sm" type="button" data-bs-target="#QPReportinfo"
                                data-bs-toggle="modal" (click)="getQpEmployee()">Employee Report</button>&nbsp;
                            <button class="btn blue-btn btn-sm ml-2 mr-1 " type="button" data-bs-toggle="modal"
                                data-bs-target="#QPinfo" (click)="isQpMapSave=true;getStatusType();">
                                Employee Client Mapping</button>&nbsp;
                            <button type="button" class="btn blue-btn btn-sm  ml-1" [disabled]="!isEnabledExcel"
                                data-bs-toggle="modal" data-bs-target="#generateReports">
                                <i class="fa fa-file-excel-o me-1"></i>Employee Info</button>
                        </div>
                    </div><br>


                    <div class="row mb-2 ">
                        <div class="col-lg-4 pl-1">
                            <!-- Languages -->
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Languages</label>
                            </div>
                            <div class="col-lg-12 d-inline-flex">
                                <ng-select [(ngModel)]="filterLanguages" class="w-100 " [searchable]="true"
                                    [clearable]="true" [multiple]="true" [items]="LanguageList" bindLabel="languageName"
                                    bindValue="id"></ng-select>
                            </div>
                        </div>
                        <!-- ClientType -->
                        <div class="col-lg-4 pl-1">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Client Type</label>
                            </div>
                            <div class="col-lg-12 d-inline-flex">
                                <ng-select [(ngModel)]="clienttypeLid" class="d-inline-flex w-100 " [searchable]="true"
                                    [clearable]="true" [items]="TypeofClient" bindLabel="lovName"
                                    bindValue="id"></ng-select>
                                <app-dropdown
                                    (EmitRefreshClick)="refreshToGetDropDownValues('CLIENTTYPE')"></app-dropdown>
                            </div>
                        </div>
                        <div class="col-lg-4 pl-1">
                            <!-- Client -->
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Client</label>
                            </div>
                            <div class="col-lg-12">
                                <!-- <ng-select [(ngModel)]="ListClientId" [searchable]="true" [clearable]="true"
                                    [items]="ClientDropDown" bindLabel="Value" bindValue="Key"
                                    [disabled]="global.globalAgencyId==0">
                                </ng-select> -->
                                <ng-select class="w-100 " [clearable]="true" [(ngModel)]="ListClientId"
                                    bindLabel="Value" bindValue="Key" [items]="ClientDropdown">
                                </ng-select>
                            </div>
                        </div>
                        <!-- Employee -->
                        <div class="col-lg-4 pl-1">
                            <div class="col-lg-12">
                                <label style="font-weight:bold">Employee</label>
                            </div>
                            <div class="col-lg-12">
                                <ng-select [clearable]="true" class="w-100" [(ngModel)]="ListEmployeeId" bindLabel="Value"
                                bindValue="Key" [items]="EmployeeDropdown">
                            </ng-select>
                            </div>
                        </div>
                        <div class="mt-2 text-end me-5">
                            <button type="button" class="btn blue-btn btn-sm mr-2"
                                (click)="ApplyFilter()">Apply</button>&nbsp;
                            <button class="btn blue-btn btn-sm" type="button" (click)="ClearFilter()" [disabled]="(this.clienttypeLid==null||clienttypeLid==undefined||clienttypeLid=='')&&(pCATypeLid==null||pCATypeLid==undefined||pCATypeLid=='')
             &&(ListEmployeeId==null||ListEmployeeId==undefined||ListEmployeeId=='')&&(ListClientId==null||ListClientId==undefined||ListClientId=='')
             &&(filterLanguages==null||filterLanguages==undefined||filterLanguages=='')">
                                Clear
                            </button>
                        </div>


                    </div>
                    <div class="row mb-2 ">
                        <div class="col-lg-12 pl-1">
                            <div class="col-lg-12">
                                <label style="font-weight:bold" class="mt-3"> </label>
                            </div>

                        </div>
                    </div>
                    <!-- gridQpClientEmployeeReport -->
                    <ejs-grid #gridQpClientEmployeeReport [dataSource]='QpInfoData | async' [allowResizing]='true'
                        [allowSorting]='true' allowPaging='true' [allowFiltering]='true'
                        [pageSettings]='QpClientEmployeeReportinitialPage ' [filterSettings]='filterOptions'
                        (dataStateChange)='dataStateChange($event)' (actionBegin)="onActionComplete($event)"
                        (resizeStop)="onResizeClientEmployeeReport($event)" [showColumnChooser]='true'
                        [allowExcelExport]='true'>
                        <e-columns>
                            <!-- Client Name -->
                            <e-column minWidth=150 field="clientName" headerText="Client" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Client Phone Number -->
                            <e-column minWidth=150 field="clientPhoneNumber" headerText="Phone" type="string"
                                [allowFiltering]="false">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Client Street -->
                            <e-column minWidth=150 field="clientStreet" headerText="Street" type="string"
                                [allowFiltering]="false">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Client Zip Code -->
                            <e-column minWidth=150 field="clientZipCode" headerText="Zip Code" type="string"
                                [allowFiltering]="false">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Client City -->
                            <e-column minWidth=150 field="clientCity" headerText="City" type="string"
                                [allowFiltering]="false">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- County -->
                            <e-column minWidth=150 field="clientCounty" headerText="County" type="string"
                                [allowFiltering]="false">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Qp Name -->
                            <e-column minWidth=150 field="employeeName" headerText="Employee Client Name" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Client Type -->
                            <e-column minWidth=150 field="clientType" headerText="Client Type" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Services -->
                            <!-- <e-column minWidth=150 field="services" headerText="Services" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column> -->
                            <!-- Languages -->
                            <e-column minWidth=150 field="clientlanguage" [allowSorting]="false"
                                [allowFiltering]="false" headerText="Languages" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- T1019.UA End Date -->
                            <!-- <e-column minWidth=150 field="serviceAggrementDate" [allowSorting]="false"
                                [allowFiltering]="false" [format]='formatOptions' headerText="End Date" type="datetime">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column> -->
                            <!-- Client Location -->
                            <e-column minWidth=150 field="clientLocation" headerText="Client Location" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Employee Location -->
                            <e-column minWidth=150 field="employeeLocation" headerText="Employee Location"
                                type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <!-- Last Supervision Visit -->
                            <!-- <e-column minWidth=150 field="lastSuperVisionVisitDate" [allowSorting]="false"
                                [allowFiltering]="false" headerText="Last Supervision Visit" type='date'
                                [allowFiltering]='false' [allowSorting]='false' [format]='formatOptions'>
                            </e-column> -->
                            <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                    <div class="d-none d-lg-block">
                                        <span id='show' (click)='showQpClientEmployeeColumn()'>
                                            <i class="fa fa-cog fa-lg" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                    <div *ngIf="QpList.length == 0" class="text-center" style="color:red">
                        <p>No data available</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- QPReportinfo -->
<span id="QPReportopen" data-bs-toggle="modal" data-bs-target="#QPReportinfo"></span>
<div class="modal hide fade modalbackgrod" id="QPReportinfo"  tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Employee Report</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-4 col-md-5 col-sm-5">
                                <label class="mr-1 label-bold ">Employee</label>
                            </div>
                            <div class="col-lg-8 col-md-5 col-sm-5">
                                <ng-select class="w-100" [(ngModel)]="QpEmployeeid" [searchable]="true"
                                    [clearable]="true" [items]="QpEmployeelist" bindLabel="empName"
                                    bindValue="empId" [ngModelOptions]="{standalone: true}">
                                </ng-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-5 col-sm-5">
                                <label class="mr-1 label-bold ">Relationship Status</label>
                            </div>
                            <div class="col-lg-8 col-md-5 col-sm-5">
                                <select class=" form-control" [(ngModel)]="QpRelationshipstatus">
                                    <option value="1">Active</option>
                                    <option value="2">InActive</option>
                                    <option value="0">All</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn blue-btn btn-sm right"
                        [disabled]="QpEmployeeid==undefined || QpEmployeeid== '' || QpEmployeeid==null" (click)="generateQpReport()">
                        Generate Report
                    </button>
                    <button type="button" class="btn blue-btn btn-sm right" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- QP-Client Mapping -->
<span id="QPopen" data-bs-toggle="modal" data-bs-target="#QPinfo"></span>
<div class="modal hide fade modalbackgrod" id="QPinfo" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Employee Client Mapping</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"
                    (click)="clearQpClientMappingFilter()"></button>
            </div>
            <div class="modal-body" >
                <div class="row mt-2 ">
                    <!-- Client -->
                    <div class="col-lg-4 pl-1">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Client</label>
                        </div>
                        <div class="col-lg-12 ">
                            <ng-select class="w-100 " [disabled]="openedFromClientPage" [clearable]="true" [(ngModel)]="clientid" bindLabel="Value"
                                bindValue="Key" [items]="ClientDropdown">
                            </ng-select>
                        </div>
                    </div>
                    <!-- Employee -->
                    <div class="col-lg-4 pl-1">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Employee</label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select [clearable]="true" class="w-100 " [(ngModel)]="employeeId" bindLabel="Value"
                                bindValue="Key" [items]="EmployeeDropdown">
                            </ng-select>
                        </div>
                    </div>
                    <!-- Status -->
                    <div class="col-lg-3 pl-1">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Status</label>
                        </div>
                        <div class="col-lg-12 d-inline-flex">
                            <ng-select class="d-inline-flex w-100" [(ngModel)]="statusLid" bindLabel="lovName"
                                bindValue="id" [items]="ClientStatus" (ngModelChange)="getQpClientMappingFilter()">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-1">
                        <div class="col-12 mt-4 pl-0">
                            <button class="btn blue-btn btn-sm mr-1 mb-1"
                                (click)="getQpClientMappingFilter();">Apply</button>
                        </div>
                    </div>
                </div>
                <div class="row mt-3 ">
                    <div class="col-lg-12">
                        <!-- Create New Mapping -->
                        <button type="button" class="btn blue-btn btn-sm mr-1 mb-1" (click)="newmap()">Create New
                            Mapping</button>&nbsp;
                        <!-- Change Status -->
                        <button type="button" class="btn blue-btn btn-sm mr-1 mb-1"
                            [disabled]="selectedCheckList.length==0" (click)="changeRelationshipStatus()">
                            Change Status </button>&nbsp;
                        <!-- Re-Assign -->
                        <button type="button" class="btn blue-btn btn-sm mr-1 mb-1"
                            [disabled]="selectedCheckList.length==0" data-bs-toggle="modal"
                            data-bs-target="#reassignStatus">
                            Re-Assign </button>
                    </div>
                </div><br>
                <div class="row ">
                    <div class="col-lg-12">
                        <!-- Grid Client Mapping -->
                        <ejs-grid #gridQpClientMapping [dataSource]='QPClientMapping |async' [allowResizing]='true'
                            [allowSorting]='true' [allowFiltering]='true' [allowPaging]='true'
                            (checkBoxChange)="checkboxSelection($event)" [selectionSettings]='selectionOptions'
                            (dataStateChange)='QPDataChange($event)' (resizeStop)="onResizeQp($event)"
                            (actionBegin)="onComplete($event)" [filterSettings]='filterOptions'
                            [pageSettings]='initialPage ' [showColumnChooser]='true'>
                            <e-columns>
                                <!-- checkbox -->
                                <e-column type='checkbox' [showInColumnChooser]='false' uid="checkbox" maxWidth=50
                                    textAlign='center' [allowEditing]='true'>
                                </e-column>
                                <!-- Actions -->
                                <e-column textAlign='center' minWidth=60 headerText="Actions" uid="action">
                                    <ng-template #template let-data>
                                        <button class="btn btn-edit-table " data-bs-target="#QPAddandUpdate"
                                            data-bs-toggle="modal" (click)="editmap(data)"><i
                                                class="fa fa-edit"></i></button>&nbsp;
                                    </ng-template>
                                </e-column>
                                <!-- clientName -->
                                <e-column minWidth=190 field="clientName" headerText="Client" type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- employeeName -->
                                <e-column minWidth=190 field="employeeName" headerText="Employee" type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="statusName" headerText="Status" type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-dropdownlist id='dropdown' placeholder='Select a Status'
                                            [dataSource]='QpDropdata' [popupHeight]='height'>
                                        </ejs-dropdownlist>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="relationshipType" headerText="RelationshipContactType"
                                    [allowFiltering]="false">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <!-- Active Date -->
                                <e-column minWidth=80 field="activeDate" headerText="Active Date" type='datetime'
                                    [format]='formatOptions'>
                                </e-column>
                                <!-- InActive Date -->
                                <e-column minWidth=80 field="inActiveDate" headerText="InActive Date" type='datetime'
                                    [format]='formatOptions'>
                                </e-column>
                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div class="d-none d-lg-block">
                                            <span id='show' (click)='showColumn()'><i class="fa fa-cog fa-lg"
                                                    aria-hidden="true">
                                                </i></span>
                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                        <div *ngIf="QpMappingList.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="clearQpClientMappingFilter()">Close</button>
            </div>
        </div>
    </div>
</div>
<!-- QPAddandUpdate -->
<span id="QPAddopen" data-bs-toggle="modal" data-bs-target="#QPAddandUpdate"></span>
<div class="modal hide fade modalbackgrod" id="QPAddandUpdate" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog  modal-lg ">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Employee Client Mapping</span>
                </h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="qpClose()"></button>
            </div>
            <div class="modal-body ">
                <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveAuthErr!=''" role="alert">
                    <p>{{saveAuthErr}}</p>
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
                        (click)="saveAuthErr=''">
                        <span aria-hidden="true"></span>
                    </button>
                </div>
                <!-- Status -->
                <div class="row ">
                    <div class="col-lg-4">
                        <label>Status<sup class="super-script mr-1">*</sup></label>
                    </div>
                    <div class="col-lg-6">
                        <ng-select class="d-inline-flex w-100" [(ngModel)]="saveClientEmployee.statusLid"
                            bindLabel="lovName" bindValue="id" [items]="QpStatusDropdown"
                            (ngModelChange)="changeStatus()">
                        </ng-select>
                    </div>
                </div>
                <!-- Client -->
                <div class="row">
                    <div class="col-lg-4">
                        <label>Client<sup class="super-script mr-1">*</sup></label>
                    </div>
                    <div class="col-lg-6">
                        <ng-select class="w-100 " [disabled]="openedFromClientPage" [clearable]="true" [(ngModel)]="saveClientEmployee.clientId"
                            bindLabel="Value" bindValue="Key" [items]="ClientDropdown">
                        </ng-select>
                    </div>
                </div>
                <!-- Employee -->
                <div class="row mt-1">
                    <div class="col-lg-4">
                        <label>Employee<sup class="super-script mr-1">*</sup></label>
                    </div>
                    <div class="col-lg-6">
                        <ng-select class="d-inline-flex w-100 " [(ngModel)]="saveClientEmployee.employeeId"
                            bindLabel="Value" bindValue="Key" [items]="EmployeeDropdown">
                        </ng-select>
                    </div>
                </div>
                <!-- RelationshipType -->
                <div class="row mt-1">
                    <div class="col-lg-4">
                        <label class="labelpad">
                            RelationshipType
                        </label>
                    </div>
                    <div class="col-lg-6 ">
                        <ng-select [items]="RelationshipTypeList" bindValue="id" bindLabel="lovName"
                            [(ngModel)]="saveClientEmployee.relationshipTypeLid " class="w-100">
                        </ng-select>
                        <app-dropdown
                            (EmitRefreshClick)="refreshToGetDropDownValues('RELATIONSHIP')"></app-dropdown>&nbsp;
                    </div>
                </div>
                <!-- Service -->
                <!-- <div class="row mt-1">
                    <div class="col-lg-4">
                        <label class="labelpad">
                            Service
                        </label>
                    </div>
                    <div class="col-lg-6  mr-1">
                        <ng-select [items]="serviceDropdown" bindValue="clientServiceId" bindLabel="serviceGroupName"
                            [multiple]="true" [(ngModel)]="saveClientEmployee.clientServiceId">
                        </ng-select>
                    </div>
                </div> -->
                <!-- Active Date -->
                <div class="row mt-1">
                    <div class="col-lg-4">
                        <label class="labelpad">
                            Active Date<sup class="super-script ">&nbsp;*</sup>
                        </label>
                    </div>
                    <div class="col-lg-6 mr-1">
                        <my-date-picker placeholder="mm/dd/yyyy" [selDate]="saveClientEmployee.activeDate"
                            [options]="myDatePickerOptions"
                            (inputFieldChanged)="DateFormat($event,'inputChanged','ActiveDate')"
                            (dateChanged)="DateFormat($event,'dateChanged','ActiveDate')">
                        </my-date-picker>
                    </div>
                </div>
                <!-- InActive Date -->
                <div class="row mt-1">
                    <div class="col-lg-4">
                        <label class="labelpad"
                            *ngIf="saveClientEmployee.statusLid!='3280029a-7998-444f-9738-45ff9d2cc945'">
                            InActive Date
                        </label>
                        <label class="labelpad"
                            *ngIf="saveClientEmployee.statusLid=='3280029a-7998-444f-9738-45ff9d2cc945'">
                            InActive Date<sup class="super-script ">&nbsp;*</sup>
                        </label>

                    </div>
                    <div class="col-lg-6 mr-1">
                        <my-date-picker placeholder="mm/dd/yyyy" [selDate]="saveClientEmployee.inActiveDate"
                            [options]="myDatePickerOptions"
                            (inputFieldChanged)="DateFormat($event,'inputChanged','InActiveDate')"
                            [disabled]="saveClientEmployee.statusLid != '3280029a-7998-444f-9738-45ff9d2cc945'"
                            (dateChanged)="DateFormat($event,'dateChanged','InActiveDate')">
                        </my-date-picker>
                    </div>
                </div>
                <!-- LiveIn -->
                <div class="row mt-1">
                    <div class="col-lg-4">
                        <label class="labelpad">
                            LiveIn
                        </label>
                    </div>
                    <div class="col-lg-6 ml-1 mr-1">
                        <input type="checkbox" [(ngModel)]='saveClientEmployee.living' />
                    </div>
                </div>
                <!-- <div class="row mt-1">
                    <div class="col-lg-4">
                        <label class="labelpad">
                            Dont Show Remaining Hours
                        </label>
                    </div>
                    <div class="col-lg-6 ml-1 mr-1">
                        <input type="checkbox" [(ngModel)]='saveClientEmployee.living' />
                    </div>
                </div> -->
            </div>
            <div class="modal-footer">
                <div>
                    <button class="btn blue-btn btn-sm"
                        *ngIf="saveClientEmployee.id=='00000000-0000-0000-0000-000000000000'" [disabled]="saveClientEmployee.employeeId==null ||saveClientEmployee.employeeId==undefined || 
            saveClientEmployee.employeeId==''|| saveClientEmployee.activeDate==null||saveClientEmployee.activeDate==undefined||saveClientEmployee.activeDate==''||
            (saveClientEmployee.statusLid== '3280029a-7998-444f-9738-45ff9d2cc945' &&
             (saveClientEmployee.inActiveDate==null||saveClientEmployee.inActiveDate==undefined||
             saveClientEmployee.inActiveDate==''))" (click)="checkInvalidDate()">Save & Close</button>
                    <button class="btn blue-btn btn-sm"
                        *ngIf="saveClientEmployee.id!='00000000-0000-0000-0000-000000000000'"
                        [disabled]="saveClientEmployee.clientId==''
            ||saveClientEmployee.employeeId==null ||saveClientEmployee.employeeId==undefined || 
            saveClientEmployee.employeeId=='' ||saveClientEmployee.employeeId==''|| saveClientEmployee.activeDate==null||saveClientEmployee.activeDate==undefined||saveClientEmployee.activeDate==''||
            (saveClientEmployee.statusLid== '3280029a-7998-444f-9738-45ff9d2cc945' && (saveClientEmployee.inActiveDate==null||saveClientEmployee.inActiveDate==undefined||saveClientEmployee.inActiveDate==''))"
                        (click)="checkInvalidDate()">Update &
                        Close</button>
                </div>
                <button type="button" class="btn blue-btn btn-sm" (click)="qpClose()">Close</button>
            </div>
        </div>
    </div>
</div>
<!-- Reassign Status -->
<span id="openReassign" data-bs-toggle="modal" data-bs-target="#reassignStatus"></span>
<div class="modal hide fade modalbackgrod" id="reassignStatus" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog  modal-lg ">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Reassign Employee</h5>
                <button type="button" class="btn-close" (click)="reassignClose()"></button>
            </div>
            <div class="modal-body ">
                <div class="row mt-1">
                    <div class="col-lg-4">
                        <label>Employee<sup class="super-script mr-1">*</sup></label>
                    </div>
                    <div class="col-lg-6">
                        <ng-select class="d-inline-flex w-100 " [(ngModel)]="reassignEmployeeId" bindLabel="Value"
                            bindValue="Key" [items]="EmployeeDropdown">
                        </ng-select>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-4">
                        <label>Active Date<sup class="super-script mr-1">*</sup></label>
                    </div>
                    <div class="col-lg-6">
                        <my-date-picker placeholder="mm/dd/yyyy" [selDate]="activeDate" [options]="myDatePickerOptions"
                            (inputFieldChanged)="DateFormat($event,'inputChanged','activeDate')"
                            (dateChanged)="DateFormat($event,'dateChanged','activeDate')">
                        </my-date-picker>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" [disabled]="
          reassignEmployeeId==null || reassignEmployeeId=='00000000-0000-0000-0000-000000000000'
            || reassignEmployeeId==undefined || activeDate==null||
            activeDate==undefined || activeDate==''
           " (click)="reassignEmployeeClientRelationship()">Save & Close</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="reassignClose()">Close</button>
            </div>
        </div>
    </div>
</div>
<!-- generateReports -->
<span id="exportaspdforexcel" data-bs-toggle="modal" data-bs-target="#generateReports"></span>
<div class="modal fade" id="generateReports" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Employee Info</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <button class="btn blue-btn btn-sm mb-1" (click)="generateExcelReport('current')">
                            Export Current page
                        </button>
                    </div>
                    <div class="col-lg-6">
                        <button class="btn blue-btn btn-sm mb-1" (click)="generateExcelReport('all')">
                            Export All page
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>


<!-- viewpowerbi -->
<span id="openPowerBiReport" data-bs-toggle="modal" data-bs-target="#viewpowerbi"></span>
<div class="modal fade" id="viewpowerbi" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">{{reptitle}}</h5>
                <div class="text-right">
                    <button class="btn blue-btn btn-sm mr-2" (click)="closePowerBimodal()">
                        Close</button>
                </div>
            </div>
            <div class="modal-body" style="height:600px">
                <ng-container *ngIf="reportcontain== true">
                    <div style="width: 100%;height:100%" class="report-border" #reportContainer></div>
                </ng-container>
            </div>
        </div>
    </div>
</div>